export function clearActivityHistoryCollectionsReducer(state) {
  return {
    ...state,
    collections: {},
    error: [],
  };
}
